import React, { useState } from 'react'
import { toast } from 'react-toastify';

type Props = {
    drInfo: any,
    setPageNumber?: (s: number) => void,
    setDeleteDr?: (b: boolean) => void,
    onClose: (b: boolean) => void,
    deleteDr?: boolean,
}
const Popup = ({ drInfo, onClose, setPageNumber = (s: number) => 1, deleteDr = false, setDeleteDr = (b: boolean) => false }: Props) => {
    const [myLoading, setMyLoading] = useState<boolean>(false);

    const deleteDrClick = () => {
        setMyLoading(true);
        const getMRObj = {
            method: "delete_doctor",
            doctor_id: drInfo?.id
        };
        fetch(`${process.env.REACT_APP_API_URL_MAIN}delete_doctor`, {
            method: "POST",
            headers: {},
            body: JSON.stringify(getMRObj),
        })
            .then((result) => {
                result.json().then((response) => {
                    if (response.status === 1) {
                        setMyLoading(false);
                        setDeleteDr(!deleteDr)
                        setPageNumber(1);
                        onClose(false)
                        toast.success("Doctor deleted successfully", {
                            position: "top-center",
                        })
                    } else {
                        setMyLoading(false);
                        onClose(false)
                    }
                });
            })
            .catch(() => {
                setMyLoading(false);
            });
    }
    return (
        <div className='shadow-lg h-50 w-50 position-absolute' style={{ backgroundColor: 'white', borderRadius: '8px', top: '25%', left: '25%', color: 'black' }}>
            <div className='p-3 w-100 h-50 d-flex justify-content-center align-items-center text-center '>
                <span style={{ fontSize: '1.8rem' }}>Are you sure want to delete <span style={{ color: 'red' }}>{drInfo?.name}</span> from doctor list ?</span>
            </div>
            <div className='p-3 w-100 h-50 d-flex justify-content-evenly align-items-center'>
                <button onClick={() => onClose(false)} style={{ borderRadius: '8px', backgroundColor: '#0071BB', color: '#ffff', border: 'none', padding: '8px', fontFamily: 'Poppins', fontSize: '16px', width: 'max-content', height: 'max-content' }} > Cancel </button>
                <button onClick={() => deleteDrClick()} style={{ borderRadius: '8px', backgroundColor: '#0071BB', color: '#ffff', border: 'none', padding: '8px', fontFamily: 'Poppins', fontSize: '16px', width: 'max-content', height: 'max-content' }}> Delete </button>
            </div>
        </div>
    )
}

export default Popup